import { mapState } from "vuex";

export default {
  name: "Terms_conditions",
  async created() {
    await this.$store.dispatch("Terms/getListAll");
  },
  computed: {
    ...mapState({
      terms: state => state.Terms.list
    })
  },
  data: () => ({
      logo:require('../../assets/Frame.svg')
  })
};
